import Storage from "../misc/storage";

export default {
  isEstablished: () => {
    return Storage.session.get("user") && Storage.session.get("systemConfig");
  },

  getUser: () => {
    if (Storage.session.get("user")) {
      return JSON.parse(Storage.session.get("user"));
    }
  },

  getSystemConfig: () => {
    if (Storage.session.get("systemConfig")) {
      return JSON.parse(Storage.session.get("systemConfig"));
    }
  },

  getLocalIpAddress: () => {
    if (
      Storage.session.get("localIpAddress") &&
      Storage.session.get("localIpAddress") !== "undefined"
    ) {
      return JSON.parse(Storage.session.get("localIpAddress"));
    }
  },

  setUser: user => {
    Storage.session.set("user", JSON.stringify(user));
  },

  setSystemConfig: systemConfig => {
    Storage.session.set("systemConfig", JSON.stringify(systemConfig));
  },

  setLocalIpAddress: localIpAddress => {
    Storage.session.set("localIpAddress", JSON.stringify(localIpAddress));
  },

  removeUser: () => {
    Storage.session.set("user", null);
  },
};



// WEBPACK FOOTER //
// ./src/misc/usersession.js